import { ApiBaseProvider } from "../context/ApiBaseContext";

/**
 * Iter-158.5.2 — Wrap the shared Hair & Makeup React pages so they
 * render inside the beta workspace with:
 *
 *   `apiBase = "/beta/hm-app/projects"` so every `useApiBase()`
 *   consumer talks to the beta_hm_full.py router (which reads
 *   from beta_* collections). No legacy leakage possible.
 *
 * Iter-158.13.2.12 — Retired the persistent "Beta · Hair & Makeup"
 * floating pill. It was a Phase-1 read-only reminder that no longer
 * matches reality (H&M writes now go through this workspace) and
 * cluttered the header on mobile. The workspace identity is already
 * visible via the page chrome and the surrounding navigation.
 */
export default function BetaHmWorkspace({ children }) {
    return (
        <ApiBaseProvider value="/beta/hm-app/projects">
            {children}
        </ApiBaseProvider>
    );
}
